import React from "react";

import { useIntl } from "react-intl";

import { Alert, Labeled } from "@mapmycustomers/ui";

import styles from "./EditBounds.module.scss";

interface Props {}

const EditBounds: React.FC<Props> = () => {
  const intl = useIntl();

  return (
    <Labeled
      label={intl.formatMessage({
        id: "map.territories.sidebar.editDrawer.bounds.title",
        defaultMessage: "Territory Bounds",
        description: "Bounds title in Edit Territory drawer in Territory Mode",
      })}
    >
      <div className={styles.container}>
        <Alert
          message={intl.formatMessage({
            id: "map.territories.sidebar.editDrawer.bounds.alert",
            defaultMessage:
              "Edit territory bounds by dragging them on the map. Right-click on vertex to delete.",
            description: "Bounds description in Edit Territory drawer in Territory Mode",
          })}
          type="info"
        />
      </div>
    </Labeled>
  );
};

export default EditBounds;
